<template>
  <div class="room" v-chat-scroll>
    <NonServiceHour v-if="!isService" />

    <div class="body">
      <div
        v-for="m in messages"
        :key="m.id"
        class="row"
        :class="{
          hide: checkIsHidden(m),
        }"
      >
        <div
          class="content"
          :class="{
            client: m.chatUserRole === 'Customer',
          }"
        >
          <div class="avatar" :class="{ bot: m.type === 'ChatRender' }"></div>
          <div class="message">
            <MessageSystem :message="m" v-if="m.type === 'System'" />
            <MessageText :message="m" v-if="m.type === 'Text'" />
            <MessageToAgent :message="m" v-if="m.type === 'ToAgent'" />
            <MessageNonService :message="m" v-if="m.type === 'NonService'" />
            <MessageOptions :message="m" v-if="m.type === 'Option'" />
            <MessageOptionSelected
              :message="m"
              v-if="m.type === 'OptionSelect'"
            />
            <MessageLink :message="m" v-if="m.type === 'Link'" />
            <MessageBot :message="m" v-if="m.type === 'ChatRender'" />
            <MessageBotRepair
              :message="m"
              v-if="m.type === 'ChatRender_Repair'"
            />
            <MessageBotWarranty
              :message="m"
              v-if="m.type === 'ChatRender_Warranty'"
            />
            <MessageTutorial :message="m" v-if="m.type === 'Tutorial'" />
            <MessageSystemRepair
              :message="m"
              v-if="m.type === 'System_Repair'"
            />
            <MessageSystemWarranty
              :message="m"
              v-if="m.type === 'System_Warranty'"
            />
            <!-- <div class="time">{{ m.createAt.slice(14, 19) }}</div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <div class="end">
        <p>{{ $t("GPT.HISTORY.CLOSE") }}</p>
        <el-button type="primary" @click="createBotRoom" :loading="gpt_loading">
          {{ $t("GPT.HISTORY.RESTART") }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import NonServiceHour from "@/components/layout/NonServiceHour";
import { languages } from "@/plugins/languages";
import MessageSystem from "@/components/gpt/MessageSystem";
import MessageText from "@/components/gpt/MessageText";
import MessageOptions from "@/components/gpt/MessageOptions";
import MessageToAgent from "@/components/gpt/MessageToAgent";
import MessageLink from "@/components/gpt/MessageLink";
import MessageOptionSelected from "@/components/gpt/MessageOptionSelected";
import MessageBot from "@/components/gpt/MessageBot";
import MessageBotRepair from "@/components/gpt/MessageBotRepair";
import MessageBotWarranty from "@/components/gpt/MessageBotWarranty";
import MessageTutorial from "@/components/gpt/MessageTutorial";
import MessageSystemRepair from "@/components/gpt/MessageSystemRepair";
import MessageSystemWarranty from "@/components/gpt/MessageSystemWarranty";
import MessageNonService from "@/components/gpt/MessageNonService";
export default {
  name: "history",
  components: {
    NonServiceHour,
    MessageSystem,
    MessageText,
    MessageOptions,
    MessageToAgent,
    MessageLink,
    MessageOptionSelected,
    MessageBot,
    MessageBotRepair,
    MessageBotWarranty,
    MessageTutorial,
    MessageSystemRepair,
    MessageSystemWarranty,
    MessageNonService,
  },
  data() {
    return {
      id: this.$route.params.id,
      showNonService: true,
    };
  },

  mounted() {
    const countryId = this.config.countryId.toUpperCase();
    const lang = languages.includes(countryId) ? countryId : "TW";
    this.$i18n.locale = lang;
  },
  methods: {
    createBotRoom() {
      this.$store.dispatch("gpt/createRoom");
    },
    checkIsHidden(m) {
      if (
        m.type === "ChatRender" ||
        m.type === "ChatRender_Repair" ||
        m.type === "ChatRender_Warranty"
      ) {
        const { Status, Result } = JSON.parse(m.content);
        if (Status == 200) {
          if (Result.ReturnMessage === "" && Result.KbList.length) {
            // KB 1.0
            return false;
          } else if (Result.ReturnMessage === "Only Chat") {
            return true;
          } else {
            // KB  2.0
            const getReturnMessage = () => {
              try {
                return JSON.parse(Result.ReturnMessage);
              } catch (e) {
                return Result.ReturnMessage;
              }
            };
            let returnMessage = getReturnMessage();

            return typeof returnMessage === "object" &&
              returnMessage.status === "SUCCESS"
              ? false
              : true;
          }
        } else {
          return true;
        }
      }
      return false;
    },
  },
  computed: {
    gpt_loading() {
      return this.$store.state.gpt.loading;
    },
    config() {
      return this.$store.state.global.config;
    },
    setting() {
      return this.$store.state.gpt.setting;
    },
    beforeChat() {
      return this.$store.state.gpt.beforeChat;
    },
    messages() {
      return this.$store.state.global.lastChatBotRoomInfo?.messages;
    },
    isService() {
      if (this.beforeChat) {
        // 等 beforeChat 拿到資料
        const { isSingleServiceTime, isServiceTime } = this.beforeChat;
        if (isSingleServiceTime && isServiceTime) {
          // 是單一服務時間的話，看 isServiceTime
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.room {
  position: relative;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
  .non-service {
    font-size: 14px;
    color: #333;
    user-select: none;
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 1;
    .non-service-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 8px;
      box-shadow: 0px 2px 6px 0px #5252521a;
      i {
        cursor: pointer;
        font-size: 20px;
      }
    }
    .non-service-content {
      padding: 8px 16px;
      box-shadow: 0px 4px 6px 0px #a8a8a81a;
    }
  }
  .body {
    flex: 1;
    padding: 10px 15px 10px 10px;
    .row {
      overflow: hidden;
      margin-bottom: 16px;
      display: flex;
      &:last-child {
        margin-bottom: 0;
      }
      .content {
        display: flex;
        width: 100%;
        overflow: hidden;
        .avatar {
          width: 30px;
          min-width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #ccc;
          margin-right: 8px;
          background-image: url("@/assets/images/avatar-genio44.svg");
          background-size: cover;
        }
        .message {
          max-width: 500px;
          font-size: 13px;
          line-height: 18px;
          flex: 1;
          overflow: hidden;
          color: #181818;
          .infos {
            font-size: 12px;
            line-height: 14px;
            display: flex;
            align-items: center;
            div {
              color: #666;
              border: 1px dashed #aaa;
              border-radius: 3px;
              padding: 1px 3px;
              margin-right: 5px;
              margin-bottom: 5px;
            }
          }
        }
      }
      .content.client {
        justify-content: end;
        .avatar {
          display: none;
        }
        .message {
          color: #262626;
          text-align: right;
          flex-direction: row-reverse;
          .infos {
            justify-content: flex-end;
          }
          .time {
            margin-left: 0;
            margin-right: 4px;
          }
        }
      }
    }
    .row.hide {
      // opacity: 0.3;
      display: none;
      position: relative;
      border: 1px solid #000;
      &::after {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        content: "隱藏";
        font-size: 80px;
        font-weight: bold;
      }
    }
  }
  .footer {
    position: sticky;
    bottom: 0;
    box-shadow: 4px 1px 12px 0px #0000001a;
    background-color: #fff;

    .end {
      width: 100%;
      background-color: #fff;
      position: sticky;
      bottom: 0;
      padding: 8px;
      display: flex;
      flex-direction: column;
      p {
        color: #666;
        text-align: center;
        font-size: 12px;
      }
      .el-button {
        width: 100%;
        margin: 0;
        margin-top: 8px;
      }
    }
  }
}

@media (max-width: 1024px) {
  .gpt-footer {
    position: fixed;
    left: 0;
  }
}
</style>
